import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=342814e9&"
import script from "./ClientPage.vue?vue&type=script&lang=js&"
export * from "./ClientPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports